import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import Application from "App";
import history from "helper/history";
import sentryHelper from "helper/sentry.helper";
import reportWebVitals from "./reportWebVitals";
import store from "./redux/store";

sentryHelper(history);

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Application />
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
